import React from 'react'
import { withTheme } from 'styled-components/macro'
import { MdCameraAlt } from 'react-icons/md'
import PropTypes from 'prop-types'
import { Container } from './ImageCounterStyledComponents'

const ImageCounter = React.memo(({ count, theme, ...rest }) => {
  return (
    count > 1 && (
      <Container {...rest}>
        <MdCameraAlt
          color={theme.productMultipleImagesIcon}
          style={{ width: '1.3em', height: '1.3em' }}
        />{' '}
        {count}
      </Container>
    )
  )
})

ImageCounter.displayName = 'ImageCounter'

ImageCounter.propTypes = {
  count: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired
}

export default withTheme(ImageCounter)
export { ImageCounter }
